export class CampaignSortField {
    static readonly Brand: number = 0;
    static readonly Product: number = 1;
    static readonly CountryId: number = 2;
    static readonly StartDate: number = 3;
    static readonly EndDate: number = 4;
    static readonly Value: number = 5;
    static readonly Live: number = 6;
    static readonly NrRatings: number = 7;
    static readonly AvgRatings: number = 8;
    static readonly TotalPlaysCount: number = 9;
    static readonly TotalCompletedViewsCount: number = 10;
    static readonly TotalEarnings: number = 11;
    static readonly DeliveryIndex: number = 12;
    static readonly AvgCompletedViewsPerDay: number = 13;
    static readonly Delivered: number = 14;
    static readonly TimeElapsed: number = 15;
    static readonly ClicksCount: number = 16;
    static readonly Ctr: number = 17;
    static readonly SharesCount: number = 18;
    static readonly Str: number = 19;
    static readonly Interactions: number = 20;
    static readonly Itr: number = 21;
    static readonly TotalAllocatedViews: number = 22;
    static readonly TradingDesk: number = 23;
    static readonly DSP: number = 24;
    static readonly SSP: number = 25;
}


// WEBPACK FOOTER //
// ./src/app/campaigns/campaign-sort.enum.ts